module.exports = __webpack_public_path__ + "static/media/appointment.b7d9c9e6.png";